import src from "IMAGE";
export default { src, width: 613, height: 415, blurWidth: 0, blurHeight: 0};
